import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Portal from '@mui/material/Portal';

export default function NotificationBar({status, setStatus}) {
    const [open, setOpen] = useState(true)

    useEffect(() => {
        setOpen(true);
        const timer = setTimeout(() => {
            setStatus('neutral');
            setOpen(false);
        }, 5000);
        return () => {
            clearTimeout(timer);
        };
    }, [status, setStatus]);

    if (status.notificationType === 'success' || status.notificationType === 'error' || status.notificationType === 'info') {
        let color, title, iconColor;
        switch (status.notificationType) {
            case 'success':
                color = '#1e4620';
                title = 'Success';
                iconColor = '#4caf50';
                break;
            case 'error':
                color = '#4a2328';
                title = 'Error';
                iconColor = '#f44336';
                break;
            case 'info':
            default:
                color = '#1a2a3a';
                title = 'Info';
                iconColor = '#2196f3';
                break;
        }
        return (
            <Portal>
              <Collapse in={open}>
                <Box sx={{
                    position: 'fixed',
                    left: 10,
                    right: 10,
                    bottom: 32,
                    zIndex: 4000,
                    width: 'auto',
                    minWidth: 0,
                    maxWidth: 'unset',
                    boxShadow: 6,
                    borderRadius: 3,
                    animation: 'fadeIn 0.5s',
                }}>
                    <Alert
                        severity={status.notificationType}
                        sx={{
                            bgcolor: color,
                            color: '#fff',
                            borderRadius: 3,
                            fontSize: '1.1rem',
                            fontWeight: 500,
                            boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
                            alignItems: 'center',
                            pr: 5,
                        }}
                        icon={false}
                        action={
                            <IconButton
                                aria-label="close"
                                size="small"
                                onClick={() => { setOpen(false); setStatus('neutral'); }}
                                sx={{ color: iconColor, position: 'absolute', right: 8, top: 8 }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                    >
                        <AlertTitle sx={{ color: iconColor, fontWeight: 700, fontSize: '1.15rem', mb: 0.5 }}>{title}</AlertTitle>
                        <span style={{ fontSize: '1.08rem', fontWeight: 600 }}>{status.message}</span>
                    </Alert>
                </Box>
                <style>{`
                    @keyframes fadeIn {
                        from { opacity: 0; transform: translateY(40px) translateX(-50%); }
                        to { opacity: 1; transform: translateY(0) translateX(-50%); }
                    }
                `}</style>
              </Collapse>
            </Portal>
        );
    } else {
        return null;
    }
}